import AppRouterView from "./AppRouter.view";
import { IAppRouterProps } from "./AppRouter.types";
import React from "react";
import { INavBarProps } from "../NavBar/NavBar.types";

interface IProps extends IAppRouterProps {
  navBarProps: INavBarProps;
}

const AppRouter: React.FC<IProps> = props => (
  <AppRouterView {...props} navBarProps={props.navBarProps} />
);

export default AppRouter;
